import './kite.scss';

import Kite from './Kite';

export default Kite;
